import React, { useState, useContext } from 'react';
import { Paper, Container, Button, Stack, TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';

import { simpleMessage } from '../../../../helpers/Helpers';
import { changeSalarioAsync, changeTipoContratoAsync } from '../../../../api/Employees';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';

const ChangeTipoContrato = ({ id, tipoContrato, setShowModal, reload, setReload }) => {
	const [fecha, setFecha] = useState(new Date());

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const saveChanges = async () => {
		const datos = {
			employeeId: id,
			tipoContrato: tipoContrato === 1 ? 2 : 1,
			fechaCambio: moment(fecha).format('YYYY-MM-DD')
		};

		setIsLoading(true);
		const result = await changeTipoContratoAsync(token, datos);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setReload(!reload);
		setIsLoading(false);
		setShowModal(false);
		simpleMessage('Tipo de Contrato Actualizado...!', 'success');
	};

	return (
		<div>
			<Container style={{ width: 550 }}>
				<Paper
					elevation={10}
					style={{
						padding: 20
					}}
				>
					<Stack spacing={2}>
						<DesktopDatePicker
							closeOnSelect
							label="Fecha de Cambio de Contrato"
							inputFormat="DD/MM/YYYY"
							value={fecha}
							onChange={(newValue) => setFecha(newValue)}
							renderInput={(params) => <TextField fullWidth {...params} />}
						/>

						<Button
							variant="outlined"
							startIcon={
								<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
							}
							fullWidth
							onClick={() => saveChanges()}
							style={{
								borderRadius: 25,
								color: '#ffc400',
								borderColor: '#ffc400',
								padding: 13
							}}
							size="large"
						>
							Cambiar Tipo de Contrato
						</Button>
					</Stack>
				</Paper>
			</Container>
		</div>
	);
};

export default ChangeTipoContrato;
